const updates = {
    tittle: `Actualizaciones Recarga-te.`,
    date: `07/01/2025`,
    descriptions: [
        `Este documento tiene el fin de explicar y ejemplificar los añadidos y actualizaciones  al sistema web de recarga-te, dichos cambios estarán presentes a partir del 10 de enero del año en curso.`,
        `A continuación se listaran las secciones del sistema donde se presentan los cambios:`,
    ],
    sections:[
        {
            tittle: `Reciclado Masivo.`,
            children: [
                {
                    description: `Se agrega la seccion de reciclado masivo.`,
                    image: `usuarios1.png`
                }
            ]
        },

    ]
}


module.exports = {
    updates
}